import MultiSelect from "atoms/forms/multi-select";
import { RecipientType } from "models/enumerations/notebooks/recipient-type";
import NotebookPermissionManifestRecord from "models/view-models/notebooks/notebook-permission-manifest-record";
import NotebookPermissionRecipientRecord from "models/view-models/notebooks/notebook-permission-recipient-record";
import useNotebookSharingDropdownOptions, {
    NotebookPermissionSelectOption,
} from "pages/notebooks/use-notebook-sharing-dropdown-options";
import React from "react";
import { t } from "utilities/localization-utils";
interface NotebookShareMultiSelectProps {
    onChange: (newVal: NotebookPermissionSelectOption[]) => void;
    currentValues: NotebookPermissionManifestRecord[];
    persistedValues: NotebookPermissionManifestRecord[];
    availableRecipients: NotebookPermissionRecipientRecord[];
    setRecipientsSearchText: React.Dispatch<React.SetStateAction<string>>;
    isLoadingRecipients: boolean;
}
const CSS_CLASS_NAME = "c-notebook-share-modal";
const NotebookShareMultiSelect = (props: NotebookShareMultiSelectProps) => {
    const {
        onChange,
        currentValues,
        persistedValues,
        availableRecipients,
        setRecipientsSearchText,
        isLoadingRecipients,
    } = props;

    const { options, value, optionFilter, handleSearchChange } =
        useNotebookSharingDropdownOptions({
            currentlySelectedOptions: currentValues,
            persistedValues,
            availableRecipients,
            setInputValue: setRecipientsSearchText,
        });

    return (
        <fieldset className={`${CSS_CLASS_NAME}__multi-select-fieldset`}>
            <label className={`sr-only`} htmlFor="notebook-share-multi-select">
                {t("shareWith")}
            </label>
            <MultiSelect
                placeholder={t("notebook-share-select--placeholder")}
                cssClassName={`${CSS_CLASS_NAME}__multi-select`}
                id="notebook-share-multi-select"
                value={value}
                onChange={onChange}
                options={options}
                renderOption={renderOption}
                optionFilter={optionFilter}
                onSearchChange={handleSearchChange}
                closeMenuOnSelect={false}
                loading={isLoadingRecipients}
                loadingMessage={t("loadingItem", { item: t("option_plural") })}
            />
        </fieldset>
    );
};

export default NotebookShareMultiSelect;

const renderOption = (option: NotebookPermissionSelectOption) => {
    const recipient = option.data?.recipient;

    const { email, name } = recipient ?? {};

    if (recipient?.type === RecipientType.User) {
        return (
            <div className="select">
                <span className="select__name">{name}</span>
                <span className="select__subtitle">{email}</span>
            </div>
        );
    }

    if (recipient?.type === RecipientType.WorkGroup) {
        return (
            <div className="select">
                <span className="select__name">{name}</span>
                <span className="select__subtitle">
                    {t("workgroup").toLowerCase()}
                </span>
            </div>
        );
    }

    return (
        <span className="select__group">
            {t("add-all-members", { teamName: name })}
        </span>
    );
};
